import {createContext} from "react";
import SimpleQRCode from "../../../../api/qr-code/SimpleQRCode";

type QRCodeFolderDialogContextType = {
    /**
     * Open the dialog
     * @since 0.1.9
     * @author Kacper Faber
     */
    open: (qrCode: SimpleQRCode) => void;

    /**
     * Close the dialog
     * @since 0.1.9
     * @author Kacper Faber
     */
    close: () => void;

    /**
     * Is dialog opened
     * @since 0.1.9
     * @author Kacper Faber
     */
    isOpened: boolean

    /**
     * QRCode to edit folder.
     * Should be undefined when dialog is not visible.
     * @author Kacper Faber
     * @since 0.1.9
     */
    qrCode: SimpleQRCode | undefined;
}

const notImplemented = () => {
    throw new Error('Not implemented!');
}

/**
 * Default value
 * @since 0.1.9
 * @author Kacper Faber
 */
const defaults: QRCodeFolderDialogContextType = {
    open: notImplemented,
    close: notImplemented,
    isOpened: false,
    qrCode: undefined
};

/**
 * Context to control QRCodeFolderDialog
 * @since 0.1.9
 * @author Kacper Faber
 */
const ctx = createContext<QRCodeFolderDialogContextType>(defaults);

export default ctx;